import PropTypes from 'prop-types'
import React from 'react'
import { OptionalRatingStars } from './OptionalRatingStars'

export interface OptionalRatingStarsProps {
  title: string
  value: number
}

export const IndividualRating = ({ title, value }: OptionalRatingStarsProps): React.ReactElement => (
  <div className='large-6 cell rating-padded'>
    <span className='color-pro-steel-grey-600 font-bold pro-text-xs'>{title}</span><br />
    <OptionalRatingStars rating={value} />
  </div>
)

IndividualRating.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired
}
